import { GetAllPersonProfileResponse } from 'domain/models';
import { PROFILE_TYPE } from 'domain/value-objects/profile-type';

const allowedRoleIds: PROFILE_TYPE[] = [
  PROFILE_TYPE.STUDENT,
  PROFILE_TYPE.ASSISTANT,
  PROFILE_TYPE.SUPPORT,
  PROFILE_TYPE.COORDINATOR,
  PROFILE_TYPE.TEACHER,
  PROFILE_TYPE.PRECEPTOR,
];

function getValidProfilesToFilters(profiles: GetAllPersonProfileResponse) {
  return (profiles || []).filter((profile) =>
    allowedRoleIds.includes(profile.roleId),
  );
}

export { getValidProfilesToFilters };
